export default {
  mounted() {
    document.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    handleKeyDown(event) {
      if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
        if (this.closeDialogOnEscape?.(event) === true) {
          return;
        }
        this.dialog = false;
      }
    },
  },
}
